import React from 'react';
import HR from '../../Components/HR';
import p1 from '../../Media/brands/hinrich-logo.webp'
import p2 from '../../Media/brands/premier-business-logo.webp'
import p3 from '../../Media/brands/Fendi_logo.webp'
import p4 from '../../Media/brands/get-capital-logo.webp'

const OurClients = () => {
    return (
        <div className='mb-24' id='What'>
            <HR>Our Clients</HR>
            <p className='md:w-5/12 text-xl'>We worked with versatile companies and helped them grow a lot with our automation technology.</p>
            <div className='lg:flex mt-10 items-center' >
                <img className='mr-8 mb-8 h-[76px]' src={p1} alt="" />
                <img className='mr-8 mb-8 h-[88px]' src={p2} alt="" />
                <img className='mr-8 mb-8 h-[85px]' src={p3} alt="" />
                <img className='mr-8 mb-8 h-[108px]' src={p4} alt="" />
            </div>
        </div>
    );
};

export default OurClients;